export default "__VITE_ASSET__CeF_xCb$__"